import React, { useEffect } from "react"
import styles from "./Tabs.module.scss"
import cn from "clsx"
import logo from "./logo-square.png"

interface TabsInterface {
    appSpaces?: boolean
    newSession: any
    setSessions: any
    sessions: any
    setActiveSession: any
    activeSession: any
}

const Tabs: React.FC<TabsInterface> = ({
    appSpaces,
    newSession,
    setSessions,
    sessions,
    setActiveSession,
    activeSession,
}) => {
    function getNextTabIndex(currentIndex: number, direction: string) {
        const maxIndex = sessions.length - 1
        let nextIndex

        if (direction === "left") {
            nextIndex = currentIndex === 0 ? maxIndex : currentIndex - 1
        } else if (direction === "right") {
            nextIndex = currentIndex === maxIndex ? 0 : currentIndex + 1
        }

        return nextIndex
    }

    function closeSession(e: any, activeTabIndex: number, session: any) {
        e.stopPropagation()
        const tabIndex = sessions.findIndex((s: any) => s.id === session.id)
        const direction = tabIndex > activeTabIndex ? "right" : "left"
        const nextTabIndex = getNextTabIndex(tabIndex, direction)

        setSessions(sessions.filter((s: any) => s.id !== session.id))

        if (sessions.length > 1) {
            setActiveSession(sessions[nextTabIndex!])
        }
    }
    useEffect(() => {
        if (sessions.length === 0) newSession()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessions])

    const getFileColor = (type: string) => {
        switch (type) {
            case "application/pdf":
                return "#FF0000"
            case "doc":
                return "#6578D8"
            case "docx":
                return "#6578D8"
            case "sheet":
                return "#5E961F"
            default:
                return "#999"
        }
    }

    return (
        <div style={{ justifyContent: appSpaces ? "end" : undefined }} className={styles.Tabs}>
            {sessions.map((session: any, index: number) => {
                return (
                    <div
                        className={cn(
                            styles.tab,
                            activeSession.id === session.id ? styles.active : undefined
                        )}
                        onClick={() => setActiveSession(session)}
                        key={index}>
                        <span
                            onClick={(e) => closeSession(e, index, session)}
                            className={cn("material-symbols-rounded", styles.close)}>
                            close
                        </span>
                        {appSpaces ? (
                            <div
                                style={{
                                    background: getFileColor(session.type),
                                }}
                                className={styles.fileType}></div>
                        ) : (
                            <img src={logo} width={20} height={20} alt="" />
                        )}
                        {session.name}
                    </div>
                )
            })}
            {!appSpaces && (
                <div onClick={() => newSession()} className={styles.newTab}>
                    <span className="material-symbols-rounded">add</span>
                </div>
            )}
        </div>
    )
}

export default Tabs
